/**
 * `@muse/url`'s `toQueryString` short-circuits on how many keys the object has, not on what
 * `stringify` makes of them, so `{ sort: undefined, page: undefined }` still yields a bare `?`.
 * Drop the empty entries before they reach it.
 */
export const definedParams = (params: Record<string, unknown>): Record<string, unknown> =>
    Object.fromEntries(
        Object.entries(params).filter(([, value]) => value !== undefined && value !== ''),
    )
